(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yumo-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var groups = document.querySelectorAll('.yumo-footer__group');
    if (!groups.length) return;
    var mq = window.matchMedia('(min-width: 750px)');

    function sync() {
      groups.forEach(function (g) {
        g.open = mq.matches; /* desktop: açık; mobil: kapalı başlar */
      });
    }

    sync();
    mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yumo-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-yumo-product]').forEach((root) => {
    // ---- Galeri: küçük görsele tıklayınca ana görsel değişir ----
    const mainImg = root.querySelector('[data-yumo-main-image]');
    const thumbs = Array.from(root.querySelectorAll('[data-yumo-thumb]'));
    if (mainImg && thumbs.length) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.getAttribute('data-src');
          if (!src) return;
          mainImg.removeAttribute('srcset');
          mainImg.setAttribute('sizes', '(min-width: 990px) 46vw, 100vw');
          mainImg.src = src;
          thumbs.forEach((t) => t.removeAttribute('aria-current'));
          thumb.setAttribute('aria-current', 'true');
        });
      });
    }

    // ---- Mobil sticky buy bar görünürlüğü ----
    const bar = root.querySelector('[data-yumo-buybar]');
    const buybox = root.querySelector('[data-yumo-buybox]');
    if (!bar || !buybox || !('IntersectionObserver' in window)) return;

    let pastBuybox = false;
    let footerVisible = false;

    const apply = () => {
      const show = pastBuybox && !footerVisible && window.matchMedia('(max-width: 989px)').matches;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.inert = !show;
      document.documentElement.classList.toggle('yumo-buybar-open', show);
    };

    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          pastBuybox = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        });
        apply();
      },
      { rootMargin: '0px' }
    ).observe(buybox);

    const footer = document.querySelector('.footer, footer');
    if (footer) {
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            footerVisible = entry.isIntersecting;
          });
          apply();
        },
        { rootMargin: '80px' }
      ).observe(footer);
    }

    window.addEventListener('resize', apply);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yumo-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-yumo-carousel]').forEach((root) => {
    const track = root.querySelector('.yumo-showcase__track');
    if (!track) return;
    const cards = Array.from(track.querySelectorAll('.yumo-showcase__card'));
    if (!cards.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const dotsWrap = root.querySelector('[data-carousel-dots]');
    const dots = [];
    if (dotsWrap) {
      cards.forEach((card, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'yumo-showcase__dot';
        dot.setAttribute('aria-label', 'Kart ' + (i + 1));
        dot.addEventListener('click', () => centerOf(cards[i]));
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    let activeIdx = -1;

    const unflip = (except) => {
      cards.forEach((card) => {
        const f = card.querySelector('[data-flip]');
        if (f && f !== except) f.setAttribute('aria-pressed', 'false');
      });
    };

    const update = () => {
      const rect = track.getBoundingClientRect();
      const center = rect.left + rect.width / 2;
      let bestIdx = 0;
      let bestD = Infinity;

      cards.forEach((card, i) => {
        const r = card.getBoundingClientRect();
        const d = center - (r.left + r.width / 2);
        const ad = Math.abs(d);
        if (ad < bestD) { bestD = ad; bestIdx = i; }
        const t = Math.min(1, ad / (r.width * 1.15));
        const rot = Math.max(-8, Math.min(8, (-d / r.width) * 10));
        card.style.transform = 'scale(' + (1.03 - t * 0.12).toFixed(3) + ') rotate(' + rot.toFixed(2) + 'deg)';
        card.style.zIndex = String(60 - Math.round(t * 40));
        card.classList.toggle('is-center', ad < r.width * 0.35);
      });

      if (bestIdx !== activeIdx) {
        activeIdx = bestIdx;
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === bestIdx));
      }
    };

    let raf = 0;
    const queue = () => {
      if (!raf) raf = requestAnimationFrame(() => { raf = 0; update(); });
    };
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);

    const centerOf = (card, behavior) => {
      track.scrollTo({
        left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2,
        behavior: behavior || (reduced ? 'auto' : 'smooth')
      });
    };

    const step = (dir) => {
      const next = cards[Math.min(cards.length - 1, Math.max(0, activeIdx + dir))];
      if (next) centerOf(next);
    };

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });

    /* Tıklama: kenar kart → merkeze; merkez kart → çevir */
    let suppressClick = false;
    cards.forEach((card, i) => {
      const flipper = card.querySelector('[data-flip]');
      if (!flipper) return;
      flipper.addEventListener('click', () => {
        if (suppressClick) return;
        if (i !== activeIdx) {
          centerOf(card);
          return;
        }
        const flipped = flipper.getAttribute('aria-pressed') === 'true';
        unflip(flipper);
        flipper.setAttribute('aria-pressed', flipped ? 'false' : 'true');
      });
    });

    /* Masaüstü fare sürüklemesi */
    let dragging = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (moved) {
        suppressClick = true;
        setTimeout(() => { suppressClick = false; }, 50);
        if (cards[activeIdx]) centerOf(cards[activeIdx]);
      }
    });

    /* Kaydırınca açık kart kapansın */
    track.addEventListener('scroll', () => unflip(null), { passive: true });

    /* Açılışta ortadaki kart merkezde: iki yanda da kart görünsün */
    centerOf(cards[Math.floor(cards.length / 2)], 'auto');
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
